import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
interface MobileLayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}
export function MobileLayout({
  children,
  noPadding = false
}: MobileLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-background" data-id="element-344">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-345" />

      <div className="lg:ml-64" data-id="element-346">
        <Header onMenuClick={() => setIsSidebarOpen(true)} data-id="element-347" />

        <main className={noPadding ? '' : 'p-4 lg:p-8 pb-safe'} data-id="element-348">
          {children}
        </main>
      </div>
    </div>;
}